// extracted by mini-css-extract-plugin
module.exports = {"customModal":"Modal_customModal__z0pva","modalWrapper":"Modal_modalWrapper__GhwNo"};